import { HttpInterceptorFn } from '@angular/common/http'
import { tokenInterceptor } from './token.interceptor'
import { jsonContentTypeInterceptor } from './json-content-type.interceptor'
import { tenantInterceptor } from './tenant.interceptor'
import { alertsInterceptor } from './alerts.interceptor'

export const httpInterceptors: HttpInterceptorFn[] = [
  tokenInterceptor,
  jsonContentTypeInterceptor,
  tenantInterceptor,
  alertsInterceptor,
]
